import { orderBy } from 'lodash';

function getOptionColumns(grid) {
  if (!grid || !grid.option) {
    return [];
  }

  const columns = grid.option('columns');

  return Array.isArray(columns) ? columns : [];
}

function getStateColumns(grid) {
  if (!grid || !grid.state) {
    return [];
  }

  const state = grid.state();
  const columns = state && state.columns;

  return Array.isArray(columns) ? columns : [];
}

export function getColumnId(column) {
  return column && (column.name || column.dataField);
}

function getColumnText(column) {
  return String((column && (column.caption || column.dataField || column.name)) || "");
}

// поиск по столбцу не должен зависеть от caption, поскольку caption могут повторяться или изменяться в зависимости от локали
function createColumnsById(columns) {
  return new Map(
    columns
      .filter((column) => getColumnId(column))
      .map((column) => [getColumnId(column), column])
  );
}

// объединяет столбец, хранящийся в состоянии
// используется идентификатор name/dataField, поэтому caption остается свойством только для отображения
export function mergeColumnWithOption(column, optionColumnsById) {
  const columnId = getColumnId(column);

  if (!columnId) {
    return column;
  }

  const optionColumn = optionColumnsById.get(columnId);

  return optionColumn ? { ...optionColumn, ...column } : column;
}

// возвращает столбцы, упорядоченные по видимому индексу и дополненные параметрами столбцов
// скрытые столбцы оставались доступными в окне выбора
export function getMergedSortedColumns(grid) {
  const optionColumns = getOptionColumns(grid);
  const stateColumns = getStateColumns(grid);
  const optionColumnsById = createColumnsById(optionColumns);
  const stateColumnIds = new Set(stateColumns.map((column) => getColumnId(column)).filter(Boolean));

  if (stateColumns.length === 0) {
    return orderBy(optionColumns, ['visibleIndex'], ['asc']);
  }

  const mergedColumns = orderBy(stateColumns, ['visibleIndex'], ['asc'])
    .map((column) => mergeColumnWithOption(column, optionColumnsById));

  optionColumns.forEach((column) => {
    const columnId = getColumnId(column);

    if (columnId && !stateColumnIds.has(columnId)) {
      mergedColumns.push(column);
    }
  });

  return mergedColumns;
}

// объединяет текущие столбцы таблицы с предыдущим снимком окна выбора
export function mergeMissingColumns(columns, fallbackColumns) {
  const fallbackColumnsById = createColumnsById(fallbackColumns);
  const mergedColumns = columns.map((column) => {
    const columnId = getColumnId(column);
    const fallbackColumn = columnId && fallbackColumnsById.get(columnId);

    return fallbackColumn ? { ...fallbackColumn, ...column } : column;
  });
  const columnIds = new Set(mergedColumns.map((column) => getColumnId(column)).filter(Boolean));

  fallbackColumns.forEach((column) => {
    const columnId = getColumnId(column);

    if (columnId && !columnIds.has(columnId)) {
      mergedColumns.push(column);
    }
  });

  return mergedColumns;
}

// возвращает видимые столбцы
export function getVisibleColumns(columns) {
  return columns.filter((column) => column && column.visible);
}

// возвращает столбцы отображаемые в пользовательском окне выбора столбцов
export function getChooserColumns(columns) {
  return columns.filter((column) => getColumnId(column) && getColumnText(column));
}

// возвращает true, если столбец выбора цели можно скрыть, не скрывая при этом последний столбец, отображаемый пользователю
export function canHideChooserColumn(columns, targetColumnId) {
  const chooserColumns = getChooserColumns(columns);
  const targetColumn = chooserColumns.find((column) => getColumnId(column) === targetColumnId);

  if (!targetColumn || !targetColumn.visible) {
    return false;
  }

  return getVisibleColumns(chooserColumns).length > 1;
}